import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BottomNavigationComponent } from './bottomNavigation.component';
import { ButtonModule } from '@app/components/button/button.module';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SafeHtmlPipeModule } from '@shared/pipes/safeHtml/safeHtml.pipe.module';

@NgModule({
  imports: [CommonModule, ButtonModule, PlIconModule, SafeHtmlPipeModule],
  declarations: [BottomNavigationComponent],
  exports: [BottomNavigationComponent],
})
export class BottomNavigationModule {}
